import { useState } from "react";

export function useRenderReset<T>(
  value: T,
  reset: () => void,
  isEqual: (previous: T, current: T) => boolean = Object.is,
) {
  const [previous, setPrevious] = useState(value);

  if (!isEqual(previous, value)) {
    setPrevious(value);
    reset();
  }
}
